<template>
  <div class="home">
    <h1 class="title">Menu</h1>

    <div
      v-if="is_loading"
      class="loader"
    >
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>

    <div class="row mt-2 px-4 mx-0">
      <div
        v-for="category in categories"
        :key="category.id"
        class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-sx-12"
      >
        <home-card
          :object_id="category.id"
          :title="category.attributes.name"
          button_text="View Items"
          button_classes="bg-white text-primary border-0 border-bottom"
          :image_source="category.attributes.image_url"
          card_classes="m-4 mb-2 home-card"
          @home_card_click="go_to_menu_items(category.id, category.attributes.name)"
        ></home-card>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategories } from '../store/api'
import Card from "../components/card";

export default {
  name: "home",

  data() {
    return {
      categories: [],
      is_loading: true,
    }
  },

  created() {
    getCategories()
      .then(response => {
        this.categories = response.data
        this.is_loading = false
      })
    this.$store.dispatch('getRestaurant')
  },

  components: {
    'home-card': Card,
  },

  methods: {
    go_to_menu_items(category_id, category_name) {
      this.$router.push({
        name: 'menu_items',
        params: {
          category_id: category_id,
          category_name: category_name
        }
      })
    },
  },

  beforeCreate: function() {
    document.body.className = '';
  },
}
</script>

<style scoped>
  .home {
    text-align: center;
  }
  .row {
    justify-content: center;
  }
</style>
